export function isTruthy<T>(
  v: T | undefined | null | false | 0 | "" /* TODO: Deal with NaN */,
): v is T {
  return Boolean(v);
}

/**
 *  Checks to make sure a variable is not null and not undefined.
 *  The type predicate means that using it in a condition branch or filter
 *  correctly narrows the type in each branch/returned array.
 *
 * @param v the variable to check that may be null
 * */
export function isDefined<T>(v: T | undefined | null): v is T {
  return v != null;
}

export function isNullish<T>(v: T | undefined | null): v is null | undefined {
  return v == null;
}

export const alwaysTrue = (..._args: unknown[]): boolean => true;

export const toggle = (val: boolean) => !val;

export const identity = <T>(v: T): T => v;
